const hotelTypes = {
  FETCHING: "HOTEL_FETCHING",
  SET_HOTELS_LIST: "SET_HOTELS_LIST",
  SET_SELECTED_HOTEL: "SET_SELECTED_HOTEL",
  SET_STATS: "SET_STATS",
  SET_VIEWS: "SET_VIEWS",
};

export default hotelTypes;
